module.exports = __webpack_public_path__ + "img/icon_IG.1955fa25.svg";